import React, { Fragment } from "react";

import { string, func } from "prop-types";

import { SelectListGroup, TextFieldGroup } from "../../../../common/index";

import { titleOptions } from "../../../../helpers/index";

const Names = ({
  memberTitle,
  memberFirstName,
  memberLastName,
  handleChange,
  titleClasses = "",
  firstNameClasses = "",
  lastNameClasses = "",
}) => (
  <Fragment>
    <div className={`form-group ${titleClasses}`}>
      <label htmlFor="title">Title</label>
      <SelectListGroup
        value={memberTitle}
        onChange={(e) => {
          handleChange("title", e.target.value);
        }}
        options={titleOptions}
        classes="register_field register_field-dropdown"
      />
    </div>
    <div className={`form-group ${firstNameClasses}`}>
      <label htmlFor="firstName">First name</label>
      <TextFieldGroup
        value={memberFirstName}
        onChange={(e) => {
          handleChange("firstName", e.target.value);
        }}
        classes="register_field"
      />
    </div>
    <div className={`form-group ${lastNameClasses}`}>
      <label htmlFor="lastName">Last name</label>
      <TextFieldGroup
        value={memberLastName}
        onChange={(e) => {
          handleChange("lastName", e.target.value);
        }}
        classes="register_field"
      />
    </div>
  </Fragment>
);

Names.propTypes = {
  memberTitle: string.isRequired,
  memberFirstName: string.isRequired,
  memberLastName: string.isRequired,
  handleChange: func.isRequired,
  titleClasses: string,
  firstNameClasses: string,
  lastNameClasses: string,
};

export default Names;
